/* eslint-disable max-lines */
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';

export const config = {
    name: 'organization',
    searchFields: [
        {
            name: '岗位',
            value: 'crmPositionName',
            type: 'input',
            isFixed: true,
            span: 6
        },
        {
            name: '用户层级',
            value: 'userLevelCode',
            type: 'select',
            optionNum: 'LCRM_USER_LEVEL',
            isFixed: true,
            span: 6
        },
        {
            name: '用户状态',
            value: 'enableFlag',
            type: 'select',
            optionNum: 'LCRM_USER_STATUS',
            isFixed: true,
            span: 6
        }
    ],
    selection: false,
    index: false,
    columns: [
        {
            label: '姓名',
            prop: 'userName',
            fixed: 'left'
        },
        {
            label: '工号',
            prop: 'employeeId'
        },
        {
            label: '账号',
            prop: 'userCode'
        },
        {
            label: '岗位',
            prop: 'crmPositionName'
        },
        {
            label: '用户层级',
            prop: 'userLevelCode',
            type: 'select',
            optionsKey: 'LCRM_USER_LEVEL'
        },
        {
            label: '所属部门',
            prop: 'orgName'
        },
        {
            label: '上级经理',
            prop: 'superiorName'
        },
        {
            label: '用户状态',
            prop: 'enableFlagName'
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 100, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '编辑',
                event: 'edit',
                displayRule: (row) => {
                    // 权限
                    return otherUtils.getHasAuth(btnAuthority.organization.editUser);
                }
            },
            {
                label: '禁用',
                event: 'disabled',
                displayRule: (row) => {
                    // 权限
                    return otherUtils.getHasAuth(btnAuthority.organization.disabled) && row.enableFlag;
                }
            },
            {
                label: '启用',
                event: 'enabled',
                displayRule: (row) => {
                    // 权限
                    return otherUtils.getHasAuth(btnAuthority.organization.enabled) && !row.enableFlag;
                }
            }
        ]
    },
    department: {
        col: 1,
        formList: [
            {
                label: '部门编码',
                prop: 'orgCode',
                value: 'orgCode',
                type: 'input',
                disabled: false,
                rule: [
                    { required: true, message: '部门编码不能为空', trigger: 'change' }
                ]
            },
            {
                label: '部门名称',
                prop: 'deptName',
                value: 'deptName',
                type: 'input',
                rule: [
                    { required: true, message: '部门名称不能为空', trigger: 'change' }
                ]
            },
            {
                label: '上级部门',
                prop: 'parentName',
                value: 'parentName',
                type: 'cascader',
                options: [],
                showAllLevels: false,
                disabled: false,
                props: { label: 'deptName', value: 'orgCode', children: 'child', checkStrictly: true },
                rule: [
                    { required: true, message: '上级部门不能为空', trigger: 'change' }
                ]
            },
            {
                label: '部门路径',
                prop: 'fullName',
                value: 'fullName',
                type: 'input',
                inputType: 'textarea',
                disabled: true,
                rows: 3
            },
            {
                label: '组织类型',
                prop: 'orgType',
                value: 'orgType',
                type: 'select',
                optionsKey: 'LCRM_ORG_TYPE'
            }
        ]
    },
    user: {
        col: 1,
        formList: [
            {
                label: '姓名',
                prop: 'userName',
                value: 'userName',
                type: 'input',
                disabled: true
            },
            {
                label: '工号',
                prop: 'employeeId',
                value: 'employeeId',
                type: 'input',
                disabled: true
            },
            {
                label: '账号',
                prop: 'userCode',
                value: 'userCode',
                type: 'input',
                disabled: true
            },
            {
                label: '岗位',
                prop: 'crmPositionName',
                value: 'crmPositionName',
                type: 'input',
                rule: [
                    { required: true, message: '岗位不能为空', trigger: 'change' }
                ]
            },
            {
                label: '用户层级',
                prop: 'userLevelCode',
                value: 'userLevelCode',
                type: 'select',
                optionsKey: 'LCRM_USER_LEVEL',
                rule: [
                    { required: true, message: '用户层级不能为空', trigger: 'change' }
                ]
            },
            {
                label: '所属部门',
                prop: 'orgName',
                value: 'orgName',
                type: 'input',
                disabled: true
            },
            {
                label: '上级经理',
                prop: 'superiorName',
                value: 'superiorName',
                name: '上级经理',
                type: 'advance',
                advanceConfig: [
                    { 'prop': 'userName', 'value': '姓名' },
                    { 'prop': 'userCode', 'value': '账号' }
                ],
                tableConfig: [
                    { 'prop': 'userName', 'value': '姓名' },
                    { 'prop': 'userCode', 'value': '账号' },
                    { 'prop': 'crmPositionName', 'value': '岗位' },
                    { 'prop': 'userLevelName', 'value': '层级' }
                ],
                prefix: '/api-lcrm',
                method: 'post',
                advanceUrl: '/lcrm/org/user/selectByCondition',
                cbParams: ['userName#superiorName', 'userCode#superiorCode']
            }
        ]
    }
};
